import { useParams } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Rocket } from "lucide-react";

const NAMES = {
  crm: "CRM & Clients", sales: "Devis & Factures", payments: "Paiements", pos: "POS / Caisse",
  inventory: "Stocks", purchasing: "Achats", accounting: "Comptabilité", treasury: "Trésorerie",
  whatsapp: "WhatsApp Business", settings: "Paramètres",
};

export default function ComingSoon() {
  const { name } = useParams();
  return (
    <div className="flex items-center justify-center py-24" data-testid="coming-soon">
      <Card className="p-10 rounded-md border-border shadow-sm text-center max-w-md">
        <div className="w-14 h-14 rounded-full bg-accent flex items-center justify-center mx-auto mb-4">
          <Rocket className="w-7 h-7 text-primary" />
        </div>
        <h1 className="font-display text-2xl font-bold">{NAMES[name] || "Module"}</h1>
        <p className="text-muted-foreground mt-2">Ce module fait partie de la feuille de route et sera activé prochainement. L'authentification, la gestion multi-entreprises et le tableau de bord dirigeant sont déjà opérationnels.</p>
      </Card>
    </div>
  );
}
